import { render, staticRenderFns } from "./consultas.vue?vue&type=template&id=2f614e4e&scoped=true"
import script from "./consultas.vue?vue&type=script&lang=js"
export * from "./consultas.vue?vue&type=script&lang=js"
import style0 from "./consultas.vue?vue&type=style&index=0&id=2f614e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f614e4e",
  null
  
)

export default component.exports